// https://facetwp.com/help-center/facets/facet-types/map/


const $ = window.jQuery;
const _ = require('./underscore-mixins');
const viewport = require('./breakpoints');

$(document).on('ready', function() {
    const FWP = window.FWP;
    const FWP_MAP = window.FWP_MAP;

    if (!FWP || !FWP_MAP) return;


    var indexItems = () => {
        return $('.map-filter-results-cols .index-item');
    };

    _.when(() => FWP_MAP.infoWindow, () => {
        FWP_MAP.infoWindow.setOptions({ minWidth: 275 });
    });


    FWP.hooks.addAction('facetwp_map/marker/click', function(marker) {
        /**
         * The post ID associated with the active marker
         */
        var post_id = marker.post_id;
        /**
         * The following code adds the CSS class "is-active" to the active post,
         * assuming each result's HTML is structured similarly to:
         * <div class="post-item" data-id="123">Hello World!</div>
         */
        var $items = indexItems();
        $items.removeClass('active');
        $items.filter('[data-id="' + post_id + '"]').addClass('active');
    });

    $(document).on('click', '.map-filter-results-cols .index-item', function(evt) {
        console.log(arguments);
        indexItems().removeClass('active');
        var $item = $(evt.currentTarget);
        $item.addClass('active');

        var markers = FWP_MAP.get_post_markers($item.data('id')),
            marker = markers[0],
            mapLocation = JSON.parse($item.attr('data-location'));

        console.log(mapLocation);

        if(mapLocation) {
          FWP_MAP.map.setZoom(mapLocation.zoom);
        } else {
          FWP_MAP.map.setZoom(16);
        }

        FWP_MAP.map.panTo(marker.position);
        FWP_MAP.infoWindow.setContent(marker.content);
        FWP_MAP.infoWindow.open(FWP_MAP.map, marker);
        //bounceMarker(markers[0]);
    });

    // Create tabs

    let isMobileTabs = false;

    let setupMobileTabs = () => {
        console.log('Current breakpoint:', viewport.current());
        if(isMobileTabs || viewport.is('>=md')) return;
        console.log('Setup mobile tabs.');
        let $listTabPane = $('.map-filter-results-list-col'),
            $mapTabPane = $('.map-filter-map-col'),
            $tabPanes = $listTabPane.add($mapTabPane);

        if(!$listTabPane.attr('id')) $listTabPane.attr('id', 'listtabpane');
        if(!$mapTabPane.attr('id')) $mapTabPane.attr('id', 'maptabpane');


        let $tabs = $(`<ul class="nav nav-tabs d-md-none ms-0 mb-3" style="margin-left:-20px;">
            <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#${$listTabPane.attr('id')}">List</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#${$mapTabPane.attr('id')}">Map</a>
            </li>
            </ul>`);

        $tabs.insertBefore('.map-filter-results-cols');

        $tabs.on('click', 'a', (evt) => {
            evt.preventDefault();
            let $tab = $(evt.currentTarget);
            let $tabPane = $($tab.attr('href'));
            $tabs.find('a').not($tab).removeClass('active');
            $tab.addClass('active');

            $tabPanes.not($tabPane).removeClass('active').hide();
            $tabPane.addClass('active').show();

            _.when(() => $mapTabPane.is('.active'), () => {
                //console.log(FWP_MAP);
                FWP_MAP.map.panToBounds(FWP_MAP.bounds);
                if(FWP_MAP.map.getZoom() == 1) {
                    FWP_MAP.map.setZoom(7);
                }
            });

        });

        $tabs.find('a').first().click();



        isMobileTabs = true;
    };

    $(window).on('resize', _.debounce((evt) => {
        //console.log(arguments);
        setupMobileTabs();
    }, 100));
    _.defer(() => setupMobileTabs());
});
